"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteItemTemplateDTO = exports.UpdateItemTemplateDTO = exports.CreateItemTemplateDTO = exports.ItemTemplateSearchFilterDTO = exports.ItemTemplateDTO = exports.ItemTemplateOrderEnum = exports.Rarity = exports.ArmorPlacements = exports.ArmorTypes = exports.WeaponTypes = exports.ItemTypes = void 0;
const class_validator_1 = require("class-validator");
const Pagination_1 = require("./Pagination");
var ItemTypes;
(function (ItemTypes) {
    ItemTypes["Weapon"] = "Weapon";
    ItemTypes["Armor"] = "Armor";
})(ItemTypes = exports.ItemTypes || (exports.ItemTypes = {}));
var WeaponTypes;
(function (WeaponTypes) {
    WeaponTypes["Slash"] = "Slash";
    WeaponTypes["Hammer"] = "Hammer";
    WeaponTypes["Rifle"] = "Rifle";
    WeaponTypes["Medigun"] = "Medigun";
})(WeaponTypes = exports.WeaponTypes || (exports.WeaponTypes = {}));
var ArmorTypes;
(function (ArmorTypes) {
    ArmorTypes["Light"] = "Light";
    ArmorTypes["Medium"] = "Medium";
    ArmorTypes["Heavy"] = "Heavy";
})(ArmorTypes = exports.ArmorTypes || (exports.ArmorTypes = {}));
var ArmorPlacements;
(function (ArmorPlacements) {
    ArmorPlacements["Head"] = "Head";
    ArmorPlacements["Body"] = "Body";
    ArmorPlacements["Legs"] = "Legs";
})(ArmorPlacements = exports.ArmorPlacements || (exports.ArmorPlacements = {}));
var Rarity;
(function (Rarity) {
    Rarity["Common"] = "Common";
    Rarity["Rare"] = "Rare";
    Rarity["Epic"] = "Epic";
    Rarity["Legendary"] = "Legendary";
    Rarity["EventDevTest"] = "EventDevTest";
})(Rarity = exports.Rarity || (exports.Rarity = {}));
var ItemTemplateOrderEnum;
(function (ItemTemplateOrderEnum) {
    ItemTemplateOrderEnum["name"] = "name";
    ItemTemplateOrderEnum["prefabName"] = "prefabName";
    ItemTemplateOrderEnum["itemType"] = "itemType";
    ItemTemplateOrderEnum["weaponType"] = "weaponType";
    ItemTemplateOrderEnum["armorType"] = "armorType";
    ItemTemplateOrderEnum["armorPlacement"] = "armorPlacement";
    ItemTemplateOrderEnum["rarity"] = "rarity";
})(ItemTemplateOrderEnum = exports.ItemTemplateOrderEnum || (exports.ItemTemplateOrderEnum = {}));
class ItemTemplateDTO {
}
exports.ItemTemplateDTO = ItemTemplateDTO;
let ItemTemplateSearchFilterDTO = (() => {
    class ItemTemplateSearchFilterDTO extends Pagination_1.PaginationRequest {
    }
    __decorate([
        Pagination_1.CompatibleOrdering(ItemTemplateOrderEnum),
        __metadata("design:type", Object)
    ], ItemTemplateSearchFilterDTO.prototype, "order", void 0);
    return ItemTemplateSearchFilterDTO;
})();
exports.ItemTemplateSearchFilterDTO = ItemTemplateSearchFilterDTO;
let CreateItemTemplateDTO = (() => {
    class CreateItemTemplateDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "prefabName", void 0);
    __decorate([
        class_validator_1.IsEnum(ItemTypes),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "itemType", void 0);
    __decorate([
        class_validator_1.IsEnum(WeaponTypes),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "weaponType", void 0);
    __decorate([
        class_validator_1.IsEnum(ArmorTypes),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "armorType", void 0);
    __decorate([
        class_validator_1.IsEnum(ArmorPlacements),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "armorPlacement", void 0);
    __decorate([
        class_validator_1.IsEnum(Rarity),
        __metadata("design:type", String)
    ], CreateItemTemplateDTO.prototype, "rarity", void 0);
    return CreateItemTemplateDTO;
})();
exports.CreateItemTemplateDTO = CreateItemTemplateDTO;
let UpdateItemTemplateDTO = (() => {
    class UpdateItemTemplateDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UpdateItemTemplateDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateItemTemplateDTO.prototype, "prefabName", void 0);
    return UpdateItemTemplateDTO;
})();
exports.UpdateItemTemplateDTO = UpdateItemTemplateDTO;
let DeleteItemTemplateDTO = (() => {
    class DeleteItemTemplateDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DeleteItemTemplateDTO.prototype, "name", void 0);
    return DeleteItemTemplateDTO;
})();
exports.DeleteItemTemplateDTO = DeleteItemTemplateDTO;
//# sourceMappingURL=ItemTemplate.js.map